import request from '@/api/config/request'

const prex = "api/admin/liberacoes/";

export function listLiberacao(query = {}) {
    return request({
        url: `${prex}pessoa`,
        method: 'get',
        params: query
    })
}

export function setHistoricoMovimento(data) {
    return request({
        url: `${prex}historico`,
        method: 'post',
        data
    })
}